import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { episodeOfCareAction } from '../../actions/constant';
import episodeOfCare from '../../../services/apiServices/episodeOfCare/episodeOfCare';
const {
  CREATE_EPISODE_OF_CARE_REQUEST,
  CREATE_EPISODE_OF_CARE_SUCCESS,
  CREATE_EPISODE_OF_CARE_FAILURE,
  CREATE_EPISODE_OF_CARE_LOADING
} = episodeOfCareAction;

function* createEpisodeOfCare(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: CREATE_EPISODE_OF_CARE_LOADING });
    const response = yield call(episodeOfCare.createEpisodeOfCare, payload?.payload);
    if (response?.status === 201) {
      yield put({ type: CREATE_EPISODE_OF_CARE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CREATE_EPISODE_OF_CARE_FAILURE, payload: error });
  }
}

function* createEpisodeOfCareSaga() {
  yield takeEvery(CREATE_EPISODE_OF_CARE_REQUEST, createEpisodeOfCare);
}

export default createEpisodeOfCareSaga;
